import { setUser } from '@sentry/browser';
import { UserProfile } from 'common/types/models/user';

export function updateUserInSentry(user: UserProfile | null) {
    if (!user) {
        setUser(null);
        return;
    }

    const { id, email } = user;
    const name = UserProfile.getName(user);
    setUser({ id, email, username: name });
}
